import React, { useState } from 'react';

interface ReadMoreTextProps {
  text: string;
  charLimit?: number;
  className?: string;
  buttonClassName?: string;
}

const ReadMoreText: React.FC<ReadMoreTextProps> = ({ 
  text, 
  charLimit = 350, 
  className = '',
  buttonClassName = ''
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!text) return null;

  const isLong = text.length > charLimit;

  if (!isLong) {
    return <span className={className}>"{text}"</span>;
  }

  const displayText = isExpanded ? text : text.slice(0, charLimit) + '...';

  return (
    <span className={className}>
      "{displayText}"
      <button 
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
        className={`ml-2 text-brand-pink font-bold hover:underline inline-block text-sm cursor-pointer ${buttonClassName}`}
      >
        {isExpanded ? 'Read less' : 'Read more'}
      </button>
    </span>
  );
};

export default ReadMoreText;
